import {useRelayEnvironment} from 'react-relay'

import type {IssueSearchType} from '../types/issue-search-type'
import {DEFAULT_ISSUE_SEARCH_TYPE, getIssueSearchTypeFromEnvironment} from '../utils/issue-search-type'

export function useIssueSearchType(): IssueSearchType {
  const relayEnvironment = useRelayEnvironment()
  return getIssueSearchTypeFromEnvironment(relayEnvironment) ?? DEFAULT_ISSUE_SEARCH_TYPE
}
